import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

const STATUS_STYLES = {
  pending_processing: "bg-[#EFEADF] text-[#5C5C5C]",
  processed: "bg-[color:var(--verified-soft)] text-[color:var(--verified)]",
  skipped: "bg-[#FBEAE4] text-[color:var(--accent)]",
};

export default function AdminImports() {
  const [imports, setImports] = useState([]);
  const load = () => api.get("/admin/imports").then(({ data }) => setImports(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.put(`/admin/imports/${id}/status`, { status });
    toast.success(status === "processed" ? "Marked processed" : "Updated");
    load();
  };

  return (
    <div data-testid="admin-imports">
      <div className="eyebrow mb-3">Vendor uploads awaiting processing</div>
      {imports.length === 0 ? (
        <div className="text-sm text-[color:var(--text-muted)]">No imports yet.</div>
      ) : (
        <div className="space-y-3">
          {imports.map(i => (
            <div key={i.import_id} data-testid={`admin-import-${i.import_id}`} className="rounded-xl border border-[color:var(--border)] p-4 flex items-center justify-between gap-3">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-semibold text-sm truncate">{i.vendor_name}</span>
                  <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] uppercase tracking-widest ${STATUS_STYLES[i.status] || STATUS_STYLES.pending_processing}`}>{i.status}</span>
                </div>
                <div className="text-xs text-[color:var(--text-muted)] mt-1 truncate">
                  {i.source} · {i.file_name || i.url} · {new Date(i.created_at).toLocaleDateString()}
                </div>
              </div>
              <div className="flex gap-2 shrink-0">
                <Button data-testid={`mark-processed-${i.import_id}`} onClick={() => setStatus(i.import_id, "processed")} className="btn-sage rounded-lg h-9">
                  <CheckCircle2 className="w-3.5 h-3.5 mr-1" /> Processed
                </Button>
                <Button variant="outline" onClick={() => setStatus(i.import_id, "skipped")} className="rounded-lg h-9">Skip</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
